// Generic helper class for returning generic error messages

export default function (fieldToValidate) {
  const i18n = window.VUE_CLI_EXPORTS.plugins.i18n

  if (!fieldToValidate.required) {
    return i18n.t('/Validations/Common Required Message')
  }

  // TODO: add more validation messages

  // If no error message is found we will return a generic message
  return i18n.t('/Validations/Common Pattern Message')
}
